import { atom } from 'recoil'

import { keyFactory } from 'src/utils/recoil'
import type { DemoTableOptions } from 'src/components/demo-table/table/toolbar'

const key = keyFactory('demo-table')

export const tableOptions = atom<DemoTableOptions>({
  key: key('table-options'),
  default: {
    showCharts: true,
    showFiveYearForecast: true,
    showNationalAvg: false,
    showCounts: false,
  },
})
